module.exports = __webpack_public_path__ + "media/pdf/smp/Muster_SCHUFA-Kurzauskunft-ff89badde85ed3a0b92f097035d28494.pdf";